import Axios from "axios";

const axios = Axios.create({
  headers: { "Cache-Control": "no-cache", Pragma: "no-cache", Expires: "-1" }
});

export default axios;
